import {
  safeGetJson,
  safeRemoveItem,
  safeSetItem,
} from '~/client/src/shared/utils/safeStorage'

// A phone that runs out of memory kills the page with no event, and Safari reloads the tab. Session
// storage is kept outside the killed process, so a run recorded there and never ended tells the
// reloaded page what happened.
const RUN_KEY = 'struxhub:mapExport:run'
// A crash reload comes within seconds; anything older is not this tab's last export.
const MAX_AGE_MS = 10 * 60_000

interface IExportRun {
  projectId: string
  startedAt: number
}

export function beginExportRun(projectId: string, now = Date.now()): void {
  const run: IExportRun = { projectId, startedAt: now }
  safeSetItem(RUN_KEY, JSON.stringify(run), 'sessionStorage')
}

export function endExportRun(): void {
  safeRemoveItem(RUN_KEY, 'sessionStorage')
}

// Whether this project's last export died with the page. Read once: the record goes either way.
export function takeInterruptedExportRun(
  projectId: string | undefined,
  now = Date.now(),
): boolean {
  const run = safeGetJson<IExportRun>(RUN_KEY, 'sessionStorage')
  if (!run) {
    return false
  }
  endExportRun()
  const age = now - run.startedAt
  return (
    !!projectId && run.projectId === projectId && age >= 0 && age < MAX_AGE_MS
  )
}
